// Estilos exclusivos do DiagramaTab (título + conteúdo da seção Diagrama de
// Equipamentos) — extraídos de circuito/styles.js na Task 6 da decomposição.
const styles = (theme) => ({
	gritItemTitle: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		flexDirection: "row",
		width: "100%",
	},
	contentIdentation: {
		pl: 5,
		pt: 2,
	},
	diagramFullscreenButton: {
		marginLeft: "auto",
		color: theme.palette.primary.main,
	},
});

export default styles;
